import { useLinked } from "@type-r/react";
import { Button, Flex, navigate, PrimaryButton } from "lqx-react/lib";
import React from "react";
import { ImportTemplateCard } from "../api/importTemplateCard";
import { ButtonsBlock, StatusDialog } from "../components/item-card-styles";
import { preventDefaultAndStopPropagation } from "../shared";

export const ImportTemplatesActions = ({ importTemplateCard, onDelete }:
    { importTemplateCard: ImportTemplateCard, onDelete?: any }) => {
    const toggleImportTemplateStatus = async () => {
        await importTemplateCard.switchStatus();
    }

    const ImportTemplateStatusToggleButton = ({ onClick }) => {
        if (importTemplateCard) {
            const $isOpen = useLinked(false);
            const btnColor = importTemplateCard.isActive ? "red" : "blue";
            const btnText = importTemplateCard.isActive ? "Deactivate" : "Activate";
            const title = importTemplateCard.isActive ? "Deactivate Import Template" : "Activate Import Template";
            const text = importTemplateCard.isActive ?
                "Are you sure you want to Deactivate this import template?" :
                "Are you sure you want to Activate this import template?";
            return <>
                <PrimaryButton
                    disabled={$isOpen.value}
                    onClick={(e) => { preventDefaultAndStopPropagation(e); $isOpen.set(true) }}
                    color={btnColor}>{btnText}
                </PrimaryButton>
                {$isOpen.value ? <StatusDialog $isOpen={$isOpen} onClick={onClick} text={text} title={title} /> : null}
            </>
        }
        else return <></>
    }

    return <>
        <ButtonsBlock>
            <Flex column justifyCenter>
                <ImportTemplateStatusToggleButton onClick={(e) => { preventDefaultAndStopPropagation(e); toggleImportTemplateStatus() }} />
            </Flex>
            <Flex column justifyCenter>
                <Button color="primary" onClick={() => navigate(`import-templates/edit/${importTemplateCard.id}`)}>Edit</Button>
            </Flex>
            {onDelete ? <Button onClick={(e) => { preventDefaultAndStopPropagation(e); onDelete(importTemplateCard.id) }} color="primary">Delete</Button> : <></>}
        </ButtonsBlock>
    </>
};